<!--AreaIntroduction:区域平台介绍页 2021/11/24 14:36:36 YuAng-->

<template>
  <div class="its-area">
    <banner :item="banner" type="area"></banner>
    <div class="its-area-part2">
      <p class="its-area-title">核心特性</p>
      <ul>
        <li v-for="(item,index) in infos" :key="'li' + index">
          <p style="margin-top: 24px">
            <img :alt="item.title" width="86px" height="86px" :src="require('../../../assets/images/area/area-part2-point' + index + '.png')" />
          </p>
          <p style="font-size: 22px;margin: 32px 0 16px 0">{{item.title}}</p>
          <p class="desc">{{item.desc1}}</p>
          <p class="desc">{{item.desc2}}</p>
          <p class="desc">{{item.desc3}}</p>
          <p class="desc">{{item.desc4}}</p>
        </li>
      </ul>
    </div>
    <div class="its-area-part3">
      <p class="its-area-title" style="padding-top: 70px">区域智慧教育，一站式解决</p>
      <img alt="mind" width="1199px" height="889px" :src="require('../../../assets/images/area/area-part3-mind.png')" />
    </div>
    <div class="its-area-part4">
      <p class="its-area-title" style="padding-top: 70px">产品介绍</p>
      <tabs :tabs="tabs" :selected-tab="selectedTab" @change-tab="changeTab"></tabs>
      <p class="its-child-desc">{{selectedChild.desc}}</p>
      <div class="its-child-show">
        <div class="its-child-left" :class="'tab' + selectedTab.id + '' + selectedChild.id">
          <el-carousel ref="carousel" class="its-carousel-child" indicator-position="none">
            <el-carousel-item v-for="i in selectedChild.imgCount" :key="i">
              <img :src="require('../../../assets/images/area/area-part4-' + selectedTab.id + '' + selectedChild.id  + '' + i + '.png')" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-show="selectedTab.children.length > 1" class="its-child-right">
          <ul class="its-child-tabs">
            <li v-for="(tab, i) in selectedTab.children" :key="'tab-' + i" class="its-child-tab" :class="{'active': tab.id === selectedChild.id}" @mouseenter="changeChildTab(tab)">
              <i class="its-icon" :class="'its-icon-area-' + selectedTab.id + '' + tab.id"></i>{{tab.title}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <connect style="background: white"></connect>
  </div>
</template>
<script>
import Tabs from '../download/components/Tabs.vue'
import Banner from './components/edition/Banner'
import Connect from './components/edition/Connect.vue'
export default {
  name: 'AreaIntroduction',
  components: { Banner, Connect, Tabs },
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      height: '775px',
      banner: {
        title: '区域智慧教育解决方案',
        desc: '专为区校打造，助力学校智慧教学，辅助区域统筹管理，实现区校<br />一体化建设，缩小区域、城乡、校际差距，促进区域教育资源均衡<br />配置'
      },
      infos: [
        {
          title: '一站式满足区校需求',
          desc1: '管理：区校一体化管理，实现统筹规划',
          desc2: '教学：备授课、自学、学情一站式服务',
          desc3: '评价：基于教、学、考的精准过程性评价',
          desc4: '研训：专业培训与研修，服务教师发展'
        },
        {
          title: '打造区校一体化资源生态',
          desc1: '精品优质资源随取随用，保障教学使用',
          desc2: '发挥名校资源引领性，促进资源创新',
          desc3: '沉淀本地化优质资源，资源共享共建'
        },
        {
          title: '云模式部署，高效安全',
          desc1: '高效性：微服务架构，部署快捷高效',
          desc2: '安全性：统一登录与认证，数据更安全',
          desc3: '经济性：部署成本低，专业团队运维',
          desc4: '开放性：底层开放，平台应用一点接入'
        },
        {
          title: '聚合数据，消除数据孤岛',
          desc1: '整合各教育业务数据，实现数据贯通',
          desc2: '数据统一智能化分析，深挖数据价值',
          desc3: '区校数据可视化展示，提供决策依据'
        }
      ],
      tabs: [
        {
          id: 1,
          mainTitle: '数字资源',
          children: [
            {
              id: 1,
              title: '高质量资源库',
              desc: '高质量资源服务，覆盖小初高全学段，有效解决教学资源不足与重复建设问题。',
              imgCount: 2
            },
            {
              id: 2,
              title: '中小学试题库',
              desc: '优质丰富试题资源，一站式解决多场景使用，组卷阅卷无缝衔接，满足教学检测需求。',
              imgCount: 2
            },
            {
              id: 3,
              title: '本地特色资源',
              desc: '沉淀地区优质资源，构建本地特色化资源库，实现区本优质资源库共建共享。',
              imgCount: 2
            }
          ]
        },
        {
          id: 2,
          mainTitle: '区域教学',
          children: [
            {
              id: 1,
              title: '智慧教学',
              desc: '以优质资源为内核，覆盖课前、课中、课后的教与学全流程，激发学习兴趣，培养自主学习能力，让教与学更高效。',
              imgCount: 1
            },
            {
              id: 2,
              title: '智慧考评',
              desc: '基于智能题库，采用“AI算法+老师助力+专家诊断”，满足区域考评需求，生成教师讲评报告、学生个性化考试报告。',
              imgCount: 2
            },
            {
              id: 3,
              title: '智慧研训',
              desc: '提供教师专业培训与研修服务，助力教师基本技能提升与职业发展，帮助教师上好每一堂课。',
              imgCount: 2
            },
            {
              id: 4,
              title: '智慧学习',
              desc: '提供丰富学生自学资源，教材同步、专项突破，助力学生个性化学习，巩固课堂学习成果。',
              imgCount: 2
            }
          ]
        },
        {
          id: 3,
          mainTitle: '区域数据',
          children: [
            {
              id: 1,
              title: '区域数据',
              desc: '对区域各校的业务数据进行汇总和分析，实现区域数据可视化，实时了解各学校情况，整体把控区域教育信息化发展概况。',
              imgCount: 1
            }
          ]
        },
        {
          id: 4,
          mainTitle: '区域管理',
          children: [
            {
              id: 1,
              title: '基础管理',
              desc: '提供区域平台全方面基础管理，满足日常管理工作的开展与运营。',
              imgCount: 1
            },
            {
              id: 2,
              title: '集成开放',
              desc: '整合教学、学习、考评、研训、管理等各类优质应用，满足个性化、多样性的智慧教与学的需求。',
              imgCount: 1
            },
            {
              id: 3,
              title: '教育门户',
              desc: '整合内外部资源，展示地区教育统一形象的专业门户，实现区域信息共享。',
              imgCount: 1
            }
          ]
        }
      ],
      selectedTab: {children:[]},
      selectedChild: {}
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.changeTab(this.tabs[0])
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: function () {
      this.$root.setHeaderBackground()
    },
    changeTab: function (tab) {
      this.selectedTab = tab
      this.changeChildTab(tab.children[0])
    },
    changeChildTab: function (tab) {
      this.selectedChild = tab
      this.$refs.carousel.setActiveItem(0)
    }
  }
}
</script>

<style scoped>
.its-area-part2 {
  padding: 70px 0 50px 0;
  text-align: center;
  height: 702px;
  background: gainsboro url("../../../assets/images/area/area-part2-bg.png")
    no-repeat;
  background-size: 100% 702px;
}

.its-area-title {
  font-family: PingFang-SC-Bold;
  font-size: 36px;
  color: #000000;
  margin-bottom: 60px;
}

.its-area-part2 ul {
  overflow: hidden;
}

.its-area-part2 li {
  background: #f9fcff;
  border: 1px solid #dbedff;
  border-radius: 10px;
  height: 418px;
  width: 300px;
  display: inline-block;
  margin-right: 12px;
  line-height: 30px;
  padding: 18px;
  vertical-align: middle;
}

.its-area-part2 .desc {
  text-align: left;
}

.its-area-part2 li:last-child {
  margin: 0;
}

.its-area-part2 li:last-child .desc {
  text-align: center;
}

.its-area-part3 {
  height: 1150px;
  text-align: center;
  background-color: white;
}

.its-area-part4 {
  height: 1000px;
  text-align: center;
  background-color: #f8f8f8;
}

.its-area-part4 >>> .its-tabs {
  background-color: #70a6fe;
  margin-top: 0;
}

.its-child-desc {
  padding-top: 120px;
  text-align: left;
  width: 1200px;
  margin: 0 auto 0 auto;
  font-size: 22px;
}

.its-child-show {
  width: 1200px;
  margin: 0 auto 0 auto;
  height: 500px;
}

.its-child-left {
  float: left;
  width: calc(100% - 333px);
  height: 510px;
  background: url(../../../assets/images/its-pc-bg.png) no-repeat;
  background-size: 717px 500px;
  margin-left: 53px;
  margin-top: 32px;
}

.its-child-left.tab24 {
  height: 453px;
  background: url(../../../assets/images/its-pad-bg.png) no-repeat;
  background-size: 768px 453px;
  margin-top: 32px;
}

.its-child-left.tab31 {
  margin-left: 220px;
}

.its-child-right {
  float: left;
  width: 240px;
}

.its-child-tabs {
  width: 260px;
  margin-top: 100px;
}

.its-child-tab {
  float: right;
  width: 216px;
  height: 52px;
  line-height: 50px;
  margin-bottom: 25px;
  cursor: pointer;
  text-align: center;
  border-radius: 26px;
  background-color: white;
  color: #50a4f8;
  font-size: 20px;
}

.its-child-tab i {
  font-size: 25px;
  margin-right: 19px;
}

.its-child-tab.active {
  width: 240px;
  height: 62px;
  line-height: 60px;
  background-color: #50a4f8;
  color: white;
  border-radius: 31px;
}

.its-carousel-child {
  margin-top: 18px;
  left: 20px;
  height: 366px;
  width: 672px;
}

.its-child-left.tab24 .its-carousel-child {
  height: 406px;
  width: 672px;
  margin-top: 24px;
  left: 56px;
}

.its-carousel-child >>> .el-carousel__container {
  height: 100%;
}

.its-carousel-child img {
  height: 100%;
  width: 100%;
}

.its-carousel-child >>> .el-carousel__arrow {
  display: none;
}
</style>